import currency from 'currency.js';

export const USD = (value: number) => currency(value, { precision: 2 });
